import { getModule } from "vuex-module-decorators";
import store from "@/store";
import Http from "@/store/http";
import Auth from "./auth";

export const httpStore: Http = getModule(Http, store);
export const authStore: Auth = getModule(Auth, store);
